import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
// import Model from '../views/Model.vue'
//import Help from "../views/Help";

Vue.use(VueRouter);

const routes = [
    // Einstieg (Ladebildschirm)
    {
        path: '/',
        component: Home,
        meta: {
            title: 'Start'
        }
    },
    // Hilfe
    // {
    //     path: '/help',
    //     component: Help
    //     //component: () => import(/* webpackChunkName: "help" */ '../views/Help.vue')
    // },

    // 3D Modell mit TextBanner
    {
        path: '/Groessenvergleich',
        component: () => import(/* webpackChunkName: "textbanner" */ '../views/020_Groessenvergleich.vue'),
        meta: {
            title: 'Größenvergleich'
        }
    },


    {
        path: '/Umlaufbahn',
        component: () => import(/* webpackChunkName: "textbanner" */ '../views/030_Umlaufbahn.vue'),
        meta: {
            title: 'Umlaufbahn'
        }
    },

    {
        path: '/Solarpanels',
        component: () => import(/* webpackChunkName: "infobox" */ '../views/050_Solarpanels.vue')
    },  

    {
        path: '/Laender',
        component: () => import(/* webpackChunkName: "textbanner" */ '../views/010_Laender.vue'),
        meta: {
            title: 'Länder'
        }
    },

    {
        path: '/Columbus',
        component: () => import(/* webpackChunkName: "textbanner" */ '../views/040_Columbus.vue'),
        meta: {
            title: 'Columbus'
        }
    },    


    {
        path: '/Astronauten',
        component: () => import(/* webpackChunkName: "textbanner" */ '../views/009_Astronauten.vue'),
        meta: {
            title: 'Deutsche Astronauten'
        }
    },


    {
        path: '/Nauka',
        component: () => import(/* webpackChunkName: "textbanner" */ '../views/060_Nauka.vue'),
        meta: {
            title: 'Nauka'
        }
    },  

 
    

    
    
    {
        path: '/Lebensende',
        component: () => import(/* webpackChunkName: "textbanner" */ '../views/070_Lebensende.vue'),
        meta: {
            title: 'Lebensende'
        }
    },  

    // {
    //     path: '/Astronauten',
    //     component: () => import(/* webpackChunkName: "textbanner" */ '../views/009_Astronauten.vue'),
    //     meta: {
    //         title: 'Deutsche Astronauten'
    //     }
    // },

    {
        path: '/Credits',
        component: () => import(/* webpackChunkName: "credits" */ '../views/080_Credits.vue'),
        meta: {
            title: 'Credits'
        }
    },
   
];

const router = new VueRouter({
    // mode: abstract, history, hash
    mode: process.env.VUE_APP_ROUTER_MODE ? process.env.VUE_APP_ROUTER_MODE : 'abstract',
    base: process.env.BASE_URL,
    routes
});

export default router
